import type { FormInputItem } from '@/components/InvoiceReportDetailDrawer/ApplicationContent/types';
import { LinkifiedText } from '@/components/LinkifiedText';
import { FC, memo } from 'react';

type TextAreaFieldViewProps = {
  item: FormInputItem;
};

export const TextAreaFieldView: FC<TextAreaFieldViewProps> = memo(
  ({ item }) => {
    return <LinkifiedText text={item.input_values?.[0]?.label ?? ''} />;
  }
);

TextAreaFieldView.displayName = 'TextAreaFieldView';
